module.exports = ".toolbar {\n    background-color: #F5F6F7;\n    padding: 9px;\n    text-align: center;\n}\n\n:host{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    height: 100%;\n    overflow: hidden;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/left-pane/left-pane.component.css
// module id = ./src/app/components/left-pane/left-pane.component.css
// module chunks = main